module.exports = __webpack_public_path__ + "media/images/wines/syrah-24-barricas/bottle-c17d0b9bc0a8ff1fa3edf93272e22d7b.png";